import React from 'react';
import { motion } from 'motion/react';
import { Scissors } from 'lucide-react';

interface AuthChoiceViewProps {
  onLogin: () => void;
  isLoading: boolean;
}

export const AuthChoiceView = ({ onLogin, isLoading }: AuthChoiceViewProps) => {
  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-[3rem] shadow-2xl shadow-slate-200/50 border border-slate-100 p-10 md:p-12 text-center"
      >
        <div className="flex flex-col items-center justify-center mb-8 gap-3">
          <div className="bg-emerald-500 p-4 rounded-3xl shadow-xl shadow-emerald-500/20">
            <Scissors className="w-8 h-8 text-white" />
          </div>
          <div className="flex flex-col items-center">
            <span className="text-2xl font-black text-slate-900 tracking-tighter leading-none">CukurJe</span>
            <span className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest mt-1">Digital Barbering</span>
          </div>
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Selamat Datang</h2>
        <p className="text-slate-500 mb-10">Masuk ke akun CukurJe Anda untuk melanjutkan</p>
        
        <div className="space-y-4">
          <button 
            disabled={isLoading}
            onClick={() => onLogin()}
            className="w-full py-5 rounded-2xl bg-emerald-500 text-white font-bold hover:bg-emerald-600 transition-all shadow-xl shadow-emerald-500/20 active:scale-[0.98] flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          >
            {isLoading ? 'Menghubungkan...' : 'Masuk dengan Google'}
          </button>
        </div>
      </motion.div>
    </div>
  );
};
